import { customAxios } from '../../common/customAxios';

interface postPokeToUserSellTractorParams {
  tractorId: string;
  reqBody: {
    suggestedPrice: number | null;
  };
}

export const postPokeToUserSellTractor = ({ tractorId, reqBody }: postPokeToUserSellTractorParams): Promise<void> => {
  return customAxios.post(`user-sell-tractors/${tractorId}/pokes`, reqBody);
};
